import React from "react";

import { GlobalContext, SideBarRef } from "../../../../utils/globalprovider.js";


import Button from "../../../../components/bases/button/button";

import ProjectForm from "../projectform/profectform.js";

import {getCurrentProjectDatas, setCurrentProjectDatas} from "../../../../utils/software.js"
import {apiGetOneProject} from  "../../../../utils/apis.js"

import imgedit from "./assets/edit.png"
import imgvisu from "./assets/visu.png"
import imgclose from "./assets/close.png"

import "./appheader.css"

class AppHeader extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)
        this.state =
        {
            display: false,
            pjid:0,
            pjdatas: {},
            displayform: false,
        }

        this.retourapi = this.retourapi.bind(this);
        this.oncloseproject = this.oncloseproject.bind(this)
        this.oneditproject = this.oneditproject.bind(this)
        this.onvalidform = this.onvalidform.bind(this)

    }

    onvalidform(datas)
    {
        console.log("ON VALID FORM", datas)
        this.props.onCancelKeyboardEvent(false)
        this.setState({displayform: false})
        if (datas.ok)
        {
            
            apiGetOneProject ({pjid:this.state.pjid}, this.retourapi)
        }
    }


    retourapi(datas)
    {
        
        if (datas.length === 0)
            this.setState({pjid:0, display:false})
        else
        {
            this.setState({pjid:datas[0].pjid, pjdatas: datas[0], display:true})
            if (this.props.pjid === 0) setCurrentProjectDatas(datas[0]);
            SideBarRef.current.projectOpen();
        }

    }


    componentDidMount()
    {

        
        var pjid = getCurrentProjectDatas().pjid;
        if (this.props.pjid !== 0)
            pjid = this.props.pjid;
        this.setNewProject(pjid)
        

        
    }

    oneditproject()
    {
        var action = "edit";
        if (this.state.pjdatas.pjsherlock.trim() !=="") action="view";

        this.setState({
            formulaire: this.state.pjdatas,
            formaction: action,
            displayform: true,
        })
        this.props.onCancelKeyboardEvent(true)


    }


    oncloseproject()
    {
        setCurrentProjectDatas(null);
        console.log("on close project")
        SideBarRef.current.projectClose();
        this.setState({pjid:0, display: false})
        if (this.props.oncloseproject) this.props.oncloseproject();

    }

    checkProject(pjid)
    {
        if (pjid === this.state.pjid)
        {
            setCurrentProjectDatas(null);
            console.log("on close project")
            SideBarRef.current.projectClose();
            this.setState({pjid:0, display: false})
    
        }
        

    }


    setNewProject(pjid)
    {
        if (pjid === 0) setCurrentProjectDatas(null);
        SideBarRef.current.projectClose();
        if (pjid === 0)
            this.setState({pjid:0, display: false})
        else
            apiGetOneProject ({pjid:pjid}, this.retourapi)
    }

    CreateOneLineTable(title, value,img=null,callback=null,tooltip=null)
    {
    
        var button = (<></>)
        if (img !=null)
            button=(
                <Button tooltip={tooltip} image={img} width={12} height={12} onClick={callback}/>
            )
        return (
            (<tr>
                <td className="headerProjectTableLeft">
                    {title}
                </td>
                <td className="headerProjectTableRight">
                    {value}&nbsp;&nbsp;{button}
                </td>

            </tr>)
        )
    }
    render()
    {


        if (!this.state.display)
            return (<></>)

      var localrender = (<></>)
      if (this.state.displayform)
      {
          localrender = (
                  <>
                    <ProjectForm
                        zindex = {2}
                        display = {this.state.displayform}
                        startposition = "center"
                        closeButton = {true}
                        onvalidform = {this.onvalidform}
                        formulaire = {this.state.pjdatas}
                        action = {this.state.formaction} />
                  </>
                );
  
      }



        var retour = [];

        if (this.props.canclose)
            retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Titre":"Title", this.state.pjdatas.pjorititle, this.props.canclose?imgclose:null,this.oncloseproject,{fr:"Fermer le projet", en:"Close project."} ));
        else
            if (this.props.canedit)
                retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Titre":"Title", this.state.pjdatas.pjorititle, this.state.pjdatas.pjsherlock.trim() !==""?imgvisu:imgedit,this.oneditproject,{fr:"Informations sur le projet.", en:"Project informations."} ));
            else
                retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Titre":"Title", this.state.pjdatas.pjorititle));



        if (this.state.pjdatas.pjsherlock.trim() !=="")
            retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Sherlock":"Sherlock", this.state.pjdatas.pjsherlock) );

        if (this.state.pjdatas.pjserie !==0)
        {
            if (this.state.pjdatas.seimage.trim() ==="")
                retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Série":"Serie", this.state.pjdatas.sename) );
            else
            {
                var serie = (
                    <>
                    <img width="20" height="20" src={this.state.pjdatas.seimage} style={{verticalAlign:"middle"}}/>
                    &nbsp;&nbsp;{this.state.pjdatas.sename}
                    </>
                )
                retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Série":"Serie", serie ));
            }
        }

        var date = this.state.pjdatas.pjdeliverydate;
        if (date.length != 10)
          date = "**/**/****";
        else
          date = date.substr(8,2)+ "/"+ date.substr(5,2)+"/"+ date.substr(0,4);


        retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Livraison":"Delivery", date) );


        if ((this.state.pjdatas.pjseason !==0) || (this.state.pjdatas.pjepisode !==0))
        {
            var ep ="";
            if (this.state.pjdatas.pjseason !==0) 
                ep = this.state.pjdatas.pjseason.toString();
            if (this.state.pjdatas.pjepisode !==0) 
            {
                if (ep !="") ep = ep +" / ";
                ep = ep + this.state.pjdatas.pjepisode.toString();
            }

            retour.push( this.CreateOneLineTable(this.context.language==="fr"?"Saison/Episode":"Season/Episode", ep) );
        }


        retour = retour.slice(0, 3);

        return(
            <>
            {localrender}
                <table className="headerProjectTable">
                    <tbody>
                    {retour}
                    </tbody>
                </table>
            </>
        )


    }

}

AppHeader.defaultProps = 
{
    display:false,
    pjid:0,
    canclose: false,
    canedit: false,
}

export default AppHeader;


